import { createSlice } from '@reduxjs/toolkit';

// State shape: { timers: { [timerId]: { value, status, paused, ... } } }
const timersSlice = createSlice({
  name: 'timers',
  initialState: {},
  reducers: {
    updateTimer: (state, action) => {
      const { timerId, value, status, paused, timerType } = action.payload;
      console.log("YASHWANTH SLICE Updating timer:", timerId, "Value:", value, "Status:", status, "Paused:", paused, "Timer Type:", timerType);
      if (!state[timerId]) {
        state[timerId] = {};
      }
      if (value !== undefined) state[timerId].value = value;
      if (status !== undefined) state[timerId].status = status;
      if (paused !== undefined) state[timerId].paused = paused;
      if (timerType !== undefined) state[timerId].timerType = timerType;
    },
    deleteTimer: (state, action) => {
      console.log("TIMERS SLICE Resetting timer:", action.payload.timerId);
      const { timerId } = action.payload;
      delete state[timerId];
    },
    resetAllTimers: (state) => {
      Object.keys(state).forEach((timerId) => {
        delete state[timerId];
      });
    },
    pauseTimer: (state, action) => {
      const { timerId } = action.payload;
      if (state[timerId]) {
        state[timerId].paused = true;
        state[timerId].status = 'paused';
      }
    },
    resumeTimer: (state, action) => {
      const { timerId } = action.payload;
      if (state[timerId]) {
        state[timerId].paused = false;
        state[timerId].status = 'running';
      }
    },
  },
});

export const { updateTimer, deleteTimer, resetAllTimers, pauseTimer, resumeTimer } = timersSlice.actions;
export default timersSlice.reducer;
